import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Short-lived shared cache for rarely-changing GETs requested by many pages (cleared after any save).
const CACHEABLE = [/^\/my-programs/, /^\/me\/consents/, /^\/foods(\?|$)/, /^\/hiit\/level/];
const getCache = new Map();
const rawGet = api.get.bind(api);
api.get = (url, config) => {
  if (!CACHEABLE.some(r => r.test(url))) return rawGet(url, config);
  const key = url + JSON.stringify(config?.params || {});
  const hit = getCache.get(key);
  if (hit && Date.now() - hit.t < 20000) return hit.p;
  const p = rawGet(url, config).catch((e) => { getCache.delete(key); throw e; });
  getCache.set(key, { t: Date.now(), p });
  return p;
};

export function localDate(d = new Date()) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('regen_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // Multi-timezone: tell the backend the client's local date + IANA timezone
  config.headers['X-Client-Date'] = localDate();
  try { config.headers['X-Client-TZ'] = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch { /* noop */ }
  return config;
});

api.interceptors.response.use(
  (r) => { if ((r.config?.method || 'get') !== 'get') getCache.clear(); return r; },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('regen_token');
      localStorage.removeItem('regen_user');
      if (!window.location.pathname.startsWith('/login') && !window.location.pathname.startsWith('/register') && window.location.pathname !== '/') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

// Private files (progress photos) need the signed-in user's token; <img> tags cannot send headers.
export function privateFileUrl(path) {
  if (!path) return null;
  if (path.startsWith('http')) return path;
  const t = localStorage.getItem('regen_token') || '';
  return `${BACKEND_URL}${path}${path.includes('?') ? '&' : '?'}auth=${encodeURIComponent(t)}`;
}
